export const MAPBOX_TOKEN = import.meta.env.VITE_MAPBOX_TOKEN as string;

export const DEFAULT_VIEWPORT = {
  longitude: -111.9431,
  latitude: 33.4484,
  zoom: 10,
};

export const MAP_STYLE = 'mapbox://styles/mapbox/light-v11';
